import { gql } from "urql";
export const GetPriorityViewsQuery = gql `
    query GetPriorityViews {
        priorityViews {
            priorityViews {
                priorityViewId
                organizationId
                name
                filter {
                    where {
                        organization_id
                        is_global
                        needs_follow_up {
                            value
                            amount
                            interval
                        }
                        without_assigned_provider
                        search
                        age_years {
                            older_than
                            younger_than
                            between
                        }
                        time_waiting_date {
                            longer_than
                            shorter_than
                            between
                        }
                        location {
                            postal_codes
                            distance_in_miles
                        }
                        days_available {
                            names
                            match
                        }
                        priority_status_id {
                            ids
                            match
                        }
                        tags {
                            names
                            match
                        }
                        condition_ids {
                            ids
                            match
                        }
                        therapy_category_ids {
                            ids
                            match
                        }
                        therapy_sub_category_ids {
                            ids
                            match
                        }
                        insurance_ids {
                            ids
                            match
                        }
                    }
                    sort {
                        field
                        order
                    }
                    pagination {
                        limit
                        offset
                    }
                }
                sortOrder
            }
        }
        priorityStatuses {
            priorityStatuses {
                priorityStatusId
                name
                colorHex
                sortOrder
                throwConfetti
                isMutable
                simpleEmailTemplateId
            }
        }
    }
`;
